module.exports = __webpack_public_path__ + "img/shouye-zixun-png-02.c496ae7c.svg";